import { useState } from 'react';
import { getFormUrl } from './formHelper';

export default function ContactSection() {
  const [submitted, setSubmitted] = useState(false);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    const honeypot = (form.elements.namedItem('company_alt') as HTMLInputElement)?.value?.trim();
    if (honeypot) { setSubmitted(true); return; }
    setLoading(true);
    setError('');
    try {
      const formData = new FormData(form);
      const url = await getFormUrl();
      const resp = await fetch(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: new URLSearchParams(formData as unknown as Record<string, string>).toString(),
      });
      const text = await resp.text();
      let parsed: Record<string, unknown> = {};
      try { parsed = JSON.parse(text); } catch { /* ignore */ }
      const code = (parsed as { code?: string })?.code;
      const msg = (parsed as { meta?: { message?: string } })?.meta?.message || (parsed as { message?: string })?.message || '';
      if (resp.ok && code === 'OK') {
        setSubmitted(true);
        form.reset();
      } else {
        setError(typeof msg === 'string' ? msg : '提交失败');
      }
    } catch {
      setError('网络错误，请重试');
    } finally {
      setLoading(false);
    }
  };

  return (
    <section id="contact" className="w-full py-16 md:py-20 bg-background-100">
      <div className="max-w-3xl mx-auto px-4 md:px-6 text-center">
        <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900">爆料投稿</h2>
        <p className="mt-3 text-sm md:text-base text-foreground-600 max-w-lg mx-auto">
          手握猛料？发现惊天大瓜？欢迎向黑料大赛投稿，你的每一次爆料都可能成为全网焦点。我们承诺严格保护爆料人隐私。
        </p>

        <div className="mt-10 bg-background-50 rounded-2xl p-6 md:p-10 border border-background-200/70">
          {submitted ? (
            <div className="py-8">
              <div className="w-16 h-16 mx-auto flex items-center justify-center rounded-full bg-accent-100 text-accent-600">
                <i className="ri-check-line text-2xl"></i>
              </div>
              <h3 className="mt-4 text-lg font-semibold text-foreground-900">爆料已收到！</h3>
              <p className="mt-2 text-sm text-foreground-600">感谢你的投稿，我们的编辑团队会尽快核实处理。</p>
            </div>
          ) : (
            <form onSubmit={handleSubmit} className="flex flex-col gap-4" data-readdy-form="">
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                <input
                  type="text"
                  name="name"
                  placeholder="你的昵称（选填）"
                  className="px-4 py-3 rounded-lg border border-background-200 bg-background-50 text-foreground-900 placeholder:text-foreground-400 text-sm focus:outline-none focus:border-accent-400 transition-colors"
                />
                <input
                  type="email"
                  name="email"
                  placeholder="联系邮箱"
                  className="px-4 py-3 rounded-lg border border-background-200 bg-background-50 text-foreground-900 placeholder:text-foreground-400 text-sm focus:outline-none focus:border-accent-400 transition-colors"
                  required
                />
              </div>
              <input
                type="text"
                name="subject"
                placeholder="爆料主题"
                className="px-4 py-3 rounded-lg border border-background-200 bg-background-50 text-foreground-900 placeholder:text-foreground-400 text-sm focus:outline-none focus:border-accent-400 transition-colors"
                required
              />
              <textarea
                name="message"
                placeholder="请详细描述你的爆料内容..."
                rows={5}
                maxLength={500}
                className="px-4 py-3 rounded-lg border border-background-200 bg-background-50 text-foreground-900 placeholder:text-foreground-400 text-sm focus:outline-none focus:border-accent-400 transition-colors resize-none"
                required
              ></textarea>
              <input
                type="text"
                name="company_alt"
                className="honeypot-field"
                tabIndex={-1}
                autoComplete="off"
                aria-hidden="true"
                readOnly
              />
              <button
                type="submit"
                disabled={loading}
                className="px-6 py-3 bg-primary-500 text-background-50 font-semibold rounded-lg hover:bg-primary-600 transition-colors duration-200 text-sm whitespace-nowrap cursor-pointer disabled:opacity-50"
              >
                {loading ? '提交中...' : '提交爆料'}
              </button>
              {error && <p className="text-red-500 text-xs">{error}</p>}
            </form>
          )}
        </div>
      </div>
    </section>
  );
}